




























import { Vue, Component, Prop } from "@/shared/vuepack";
import { useWizardStore } from "@/employee/store/wizard";
import Button from "@/shared/components/ui/Button.vue";

@Component({
  components: {
    Button
  }
})
export default class UnsavedChangesPrompt extends Vue {
  wizardStore = useWizardStore();

  @Prop({ required: true })
  onLeave: () => void;

  get isOpen () {
    return this.wizardStore.showUnsavedChangesPrompt;
  }

  handleLeave () {
    this.wizardStore.unsavedChangesConfirmed();
    this.onLeave();
  }

  handleStay () {
    this.wizardStore.unsavedChangesConfirmed();
  }
}
